
import { App } from '@capacitor/app'
import { navigateValidDeepLink } from '~/lib/url/deepLink'

export default {
  data() {
    return {
      navigation: this.$envConfig.navigation,
      notificationPosition: window.innerWidth < 768 ? 'bottom' : 'top'
    }
  },
  head() {
    const defaultFavicon = '/favicon/vsm.png'
    const safariFavicon = '/favicon/vsm-black.svg'
    const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
    return {
      title: this.$t('app_name'),
      htmlAttrs: i18nHead.htmlAttrs,
      meta: [
        { hid: 'description', name: 'description', content: '' },
        ...i18nHead.meta
      ],
      link: [
        {
          hid: 'icon',
          rel: 'icon',
          type: 'image/png',
          href: defaultFavicon
        },
        // iOS Web
        {
          hid: 'apple-touch-icon',
          rel: 'apple-touch-icon',
          type: 'image/png',
          href: defaultFavicon
        },
        // Safari (pinned tab)
        {
          hid: 'mask-icon',
          rel: 'mask-icon',
          href: safariFavicon,
          color: '#00BBEE'
        },
        ...i18nHead.link
      ],
      script: [
        {
          src: `https://maps.googleapis.com/maps/api/js?key=${this.$envConfig.API_KEY_GOOGLE_PLACES}&libraries=places`,
          body: true
        }
      ]
    }
  },
  computed: {
    loading() {
      return this.$store.getters['user/loadingSources']
    },
    user() {
      return {
        name: this.$store.getters['user/profile'].name || 'No Name',
        email:
          this.$store.getters['user/profile'].email || 'no@email.example.com'
      }
    },
    isNative() {
      return this.$platform.isNative
    },
    isLoggedIn() {
      return this.$auth.loggedIn
    }
  },
  watch: {
    '$nuxt.isOnline': {
      handler(online) {
        const onlinePayload = {
          message: this.$t('messages.online')
        }
        const offlinePayload = {
          type: 'warning',
          message: this.$t('warnings.no_internet'),
          dismiss: false,
          timeout: 99999999
        }
        if (online) {
          this.$store.dispatch('notify/info', onlinePayload)
          this.$store.dispatch('notify/hide', offlinePayload)
        } else {
          this.$store.dispatch('notify/dialog', offlinePayload)
          this.$store.dispatch('notify/hide', onlinePayload)
        }
      }
    }
  },
  created() {
    this.$store.dispatch('queue/setup')
  },
  async mounted() {
    if (!this.isLoggedIn) return
    window.onresize = () => {
      this.notificationPosition = window.innerWidth < 768 ? 'bottom' : 'top'
    }

    // capture change to visibility
    document.addEventListener('visibilitychange', () => {
      // re-retch date on current route when tab was re-activated
      if (document.visibilityState === 'visible') {
        this.$apolloProvider.defaultClient.restore()
        this.$apolloProvider.defaultClient.reFetchObservableQueries()
        this.$nuxt.refresh()
      }
    })

    await this.$platform.native.notifications.setup() // set up notifications if already allowed
    this.$platform.native.notifications.addListeners()

    if (this.$platform.isNative) {
      this.handleDeepLink()
    }

    // TEMP: sync warranty things from local storage
    this.$store.dispatch('warranty/syncProducts')
  },
  methods: {
    async handleDeepLink() {
      const { url } = (await App.getLaunchUrl()) ?? {}
      navigateValidDeepLink(this, url)
    }
  }
}
